import { request } from "react-rb/request"

/**
 * @typedef CommandPaletteSubscriber
 * @type {object}
 * @property {number} id
 * @property {string} email_address
 * @property {?string} first_name
 */

/**
 * Search subscribers by email for the command palette.
 *
 * @param {object} params
 * @param {string} params.query Partial email term.
 * @returns {Promise<{ subscribers: CommandPaletteSubscriber[] }>}
 */
export async function searchSubscribers({ query }) {
  const params = new URLSearchParams({ q: query })

  const response = await request(`/command_palette/subscribers?${params}`, {
    method: "GET",
    throwOnError: true
  })

  return response.data
}

/**
 * @typedef CommandPaletteTag
 * @type {object}
 * @property {number} id
 * @property {string} name
 */

/**
 * Fetch the account's full tag list for the command palette. The palette
 * filters it client-side, so it's fetched once per subpage visit rather than
 * per keystroke.
 *
 * @returns {Promise<{ tags: CommandPaletteTag[] }>}
 */
export async function fetchTags() {
  const response = await request("/command_palette/tags", {
    method: "GET",
    throwOnError: true
  })

  return response.data
}
